// Inferred from kyc_review_decisions for the invitation person. Null/undefined
// means there wasn't ever a team KYC row for the admin, due to historic reasons.
// Team management settings UI only treats PENDING specially.
export enum AdminKycStatus {
  Pending = 'PENDING',
  Approved = 'APPROVED',
  Rejected = 'REJECTED',
}
